import i18next from 'i18next'
import {initReactI18next} from 'react-i18next'
import ar from './locales/ar.json';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';


i18next
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: navigator.language || navigator.userLanguage,
    resources: {
      ar: {translation: ar},
      de: {translation: de},
      en: {translation: en},
      es: {translation: es},
      fr: { translation: fr },
      it: { translation: it },
      pt: { translation: pt },
      ru: { translation: ru },
      zh: {translation: zh},
    },
    interpolation: {
      escapeValue: false
    },
    wait: true
  });

export default i18next;

